import qunar from './Qunar';
import ctrip from './Ctrip';
import ctripHuodong from './CtripHuoDong';
import mtticket from './MTticket';

export default {
  qunar,
  ctrip,
  ctripHuodong,
  mtticket,
};